import React from 'react';
import { Card } from './../Card/Card';

/**
 * Print-only counterpart of RouteTools for users without admin rights.
 *
 * RouteTools cannot be reused here: it is gated on isAdmin and hardcodes
 * /admin/... URLs. The warehouse PDF route already exists
 * (warehouse.pdf.list_route), so this only needs the prefix-aware link.
 */
export const RoutePrintTools = ({ routeId }) => (
  <Card title={__('routes.tools')}>
    <a
      type="button"
      className="btn btn-primary mr-5px mt-5px"
      href={`/${window.urlPrefix}/routes/list/${routeId}`}
      target="_blank"
      data-testid="route-print-list"
    >
      {__('routes.print_list')}
    </a>
  </Card>
);
